module.exports = __webpack_public_path__ + "img/150.406b07df.png";